import {
    AxiosResponse
} from 'axios';
import {
    bexHttpClient
} from '../../clients';
import {
    KbDataResponse,
} from '../bexService.types';
/**
 * Service class for performing sub-organization operations.
 */
class SubOrganizationService {

    /**
     * Gets sub organization kb information
     * @param {string} organizationId - The ID of the organization.
     * @param {string} subOrganizationId - The ID of the sub-organization.
     * @returns {Promise<KbDataResponse>} The response of kb data.
     */
    async subOrganizationKbData(organizationId: string, subOrganizationId: string): Promise<KbDataResponse> {
        const response = await bexHttpClient.get(`/db/sub-organizations/get-sub-organization-kb-data?organizationId=${organizationId}&subOrganizationId=${subOrganizationId}`);
        return response;
    }

    /**
     * creates Milvus collection for sub-organization
     * @param {object} data - The ID of the organization.
     * @param {string} data.organizationId - The ID of the organization.
     * @param {string} data.subOrganizationId - The ID of the sub-organization.
     * @returns {Promise<AxiosResponse<{message: string}>>} The response after creating Milvus collection.
     */
    async createMilvusCollection(data: { organizationId: string, subOrganizationId: string }): Promise<AxiosResponse<{message: string}>> {
        const response = await bexHttpClient.post('/db/sub-organizations/create-sub-organization-milvus-collection', data);
        return response;
    }

    /**
     * creates Milvus collection for sub-organization
     * @param {object} data - The ID of the organization.
     * @param {string} data.organizationId - The ID of the organization.
     * @param {string} data.subOrganizationId - The ID of the sub-organization.
     * @returns {Promise<AxiosResponse<{message: string}>>} The response after creating Milvus collection.
     */
    async deleteMilvusCollection(data: { organizationId: string, subOrganizationId: string }): Promise<AxiosResponse<{message: string}>> {
        const response = await bexHttpClient.delete('/db/sub-organizations/delete-sub-organization-milvus-collection', {
            data
        });
        return response;
    }

}

const subOrganizationService = new SubOrganizationService();
export { subOrganizationService };